import {
  Box,
  Button,
  Chip,
  Divider,
  Grid2,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MenuItemMui from "@mui/material/MenuItem";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { Calculate } from "@mui/icons-material";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const CoarseAggrigate25mmDetails = ({
  mainData,
  setMainData,
  isNonMobile,
  concreteMixtureArray,
  chartData,
  calculationOfChart,
  setChartData,
}) => {
  const handleDateOfCast = (newVal) => {
    setMainData((pre) => ({
      ...pre,
      dateOfCast: dayjs(newVal).format("YYYY-MM-DD"),
    }));
    // setDatDiff(calculateDaysBetween);
  };

  const [errorCheck, setErrorCheck] = useState({
    serialNo: {
      error: false,
    },
    dateOfCast: {
      error: false,
    },
    dateOfTest: {
      error: false,
    },
    weight: {
      error: false,
    },
    concreteMixture: {
      error: false,
    },
    areaOfCube: {
      error: false,
    },
    compressiveStrength: {
      error: false,
    },
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        display="grid"
        gap={0.5}
        alignItems="center"
        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
        sx={{
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 6",
          },
        }}
      >
        <DemoContainer
          components={["DatePicker"]}
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          <div style={{ width: "190px" }}>
            <DatePicker
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: "40px",
                  overflow: "hidden",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                },
              }}
              label="Date of Aggregate"
              size="small"
              format="YYYY-MM-DD"
              timezone="Asia/Colombo"
              // error={errorCheck.dateOfCast.error}
              value={
                mainData.dateOfCast
                  ? dayjs(mainData.dateOfCast).tz("Asia/Colombo", true)
                  : dayjs().tz("Asia/Colombo", true)
              }
              onChange={(newVal) => {
                const colomboTime = newVal?.tz("Asia/Colombo", true);
                handleDateOfCast(colomboTime);
              }}
            />
          </div>
        </DemoContainer>

        <TextField
          fullWidth
          variant="outlined"
          type="text"
          label="Sample No"
          size="small"
          value={mainData.cement}
          onChange={(e) =>
            setMainData((pre) => ({
              ...pre,
              cement: e.target.value,
            }))
          }
          sx={{ gridColumn: "span 1", marginTop: "5px" }}
        />
        <TextField
          select
          label="Aggregate"
          fullWidth
          size="small"
          error={errorCheck.concreteMixture.error}
          defaultValue=""
          sx={{ marginTop: "5px", gridColumn: "span 1" }}
          value={mainData.concreteMixture.value}
          onChange={(e) => {
            const selectedValue = e.target.value;
            const selectedOption = concreteMixtureArray.find(
              (item) => item.value === selectedValue,
            );
            setMainData((pre) => ({
              ...pre,
              concreteMixture: selectedOption.label,
              grade: e.target.value,
            }));
          }}
        >
          {concreteMixtureArray.map((data) => (
            <MenuItemMui
              key={data.id}
              data-label={data.label}
              value={data.value}
            >
              {data.label}
            </MenuItemMui>
          ))}
        </TextField>
      </Box>
      <Divider sx={{ margin: "5px 0px 5px 0" }} />

      <Box justifyItems="center">
        <Paper variant="elevation" elevation={2} sx={{ padding: "10px" }}>
          <Box
            display="grid"
            gap={0.5}
            alignItems="center"
            gridTemplateColumns="repeat(7, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 7",
              },
            }}
          >
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              variant="h6"
              textAlign="center"
            >
              SIEVE SIZE (mm)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              WEIGHT RETAINED (g)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              RETAINED (%)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              CUM (%)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              PASSING (%)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              SPEC VALUE (SINGLE SIZE)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              SATISFACTORY
            </Typography>
            <TextField
              value={chartData.sieve3750.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight3750}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight3750: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain3750.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum3750.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing3750.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec3750}
              size="small"
              variant="outlined"
              disabled
              sx={{
                gridColumn: "span 1",
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  fontSize: "14px",
                  color: "blue",
                },
              }}
              inputProps={{
                style: {
                  textAlign: "center",
                  fontSize: "14px",
                },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec3750pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec3750pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve25.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight25}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight25: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain25.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum25.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing25.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec25}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec25pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec25pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve20.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight20}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight20: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain20.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum20.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing20.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec20}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec20pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec20pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve14.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight14}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight14: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain14.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum14.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing14.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec14}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec14pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec14pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve10.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight10}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight10: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain10.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum10.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing10.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec10}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec10pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec10pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve05.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight05}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight05: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain05.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum05.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing05.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec05}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec05pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec05pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>

            <TextField
              value={chartData.sieve0.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight0}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight0: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain0.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum0.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing0.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value="-"
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="success"
              textAlign="center"
              variant="h6"
            >
              -
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h4"
            >
              TOTAL
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h4"
            >
              {chartData.totalValueOfWeight.toFixed(3)}
            </Typography>
          </Box>
          <Divider sx={{ marginTop: "10px" }} />
          <Button
            variant="contained"
            color="success"
            sx={{ gridColumn: "span 1", marginTop: "5px" }}
            startIcon={<Calculate />}
            onClick={calculationOfChart}
          >
            Calculate
          </Button>
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default CoarseAggrigate25mmDetails;
